import { useState,useEffect} from 'react';
import Post from './Post';
import {db} from './FirebaseConfig';
import './styles/Feed.css';

const Feed = ({profile}) => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        if (profile == null || profile == ''){
            db.collection('posts').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
                setPosts(snapshot.docs.map(doc => ({
                    id : doc.id,
                    post : doc.data()
                })));
            })
        }
        else{
            db.collection('posts').where('username', '==', profile).orderBy('timestamp', 'desc').onSnapshot(snapshot => {
                setPosts(snapshot.docs.map(doc => ({
                    id : doc.id,
                    post : doc.data()
                })));
            })
        }   
    }, []);

    return(
        <div className = 'feed'>
            {
                posts.map(({id, post}) => (
                    <Post key = {id}
                          postId = {id}
                          username = {post.username}
                          caption = {post.caption}
                          image = {post.image}
                    />
                ))
            }
        </div>
    );
}

export default Feed;